import api from '../utils/api'
import { API_ROOT } from '../constants'

export const getSsoStatus = () => api.get(`${API_ROOT}/v3/sso/status`)

export const createSsoSetupLink = (body = {}) => api.post(`${API_ROOT}/v3/sso/setup-link`, body)

export const getSetupLinkUrl = (setupLink) => setupLink?.url || setupLink?.data?.url || null
